// 请求模块
export const UPDATE_ADD_REQUEST_COUNT = "UPDATE_ADD_REQUEST_COUNT";
export const UPDATE_SUBTRACT_REQUEST_COUNT = "UPDATE_SUBTRACT_REQUEST_COUNT";

// 批量打印模块
export const SET_UPLOAD_LISTS = "SET_UPLOAD_LISTS";
export const SET_IS_UPLOADING = "SET_IS_UPLOADING";
export const UPDATE_UPLOAD_FILE_PERCENTAGE = "UPDATE_UPLOAD_FILE_PERCENTAGE";
export const SET_ORDER = "SET_ORDER";

// 用户模块
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_USER_TYPE = "UPDATE_USER_TYPE";
export const UPDATE_ACCOUNTS = "UPDATE_ACCOUNTS";
export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
export const UPDATE_ACCESS_TOKEN_TYPE = "UPDATE_ACCESS_TOKEN_TYPE";